import { render, staticRenderFns } from "./CompanyOmbudsmanTask.vue?vue&type=template&id=a51a7fc2&"
import script from "./CompanyOmbudsmanTask.vue?vue&type=script&lang=js&"
export * from "./CompanyOmbudsmanTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports